import { useTranslation } from 'react-i18next';

const Beneficios = () => {

    const { t } = useTranslation();

    return (
        <div className="container">
            <reward-benefits id="benefits">
                <div className="container">
                    <h2 className="mb-5">
                        TUS BENEFICIOS <span style={{ color: "rgb(150, 113, 38)" }}>{t("DESDE EL PRIMER DÍA")}</span>
                    </h2>
                    <div className="mb-6">
                        <ul className="o-rw-list o-rw-list-features">
                            <li className="col-md-6 col-xl-3">
                                <figure>
                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_DESCUENTO_Negro.svg" />
                                </figure>
                                <span>
                                    <strong className="rewards-color mb-md-3 text-up-md d-block">{t("5% de descuento garantizado")}</strong> {t("Disfruta de mínimo un 5% de descuento en todas las reservas en nuestras webs ")}</span>
                            </li>
                            <li className="col-md-6 col-xl-3">
                                <figure>
                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_NOCHE_Negro.svg" />
                                </figure>
                                <span>
                                    <strong className="rewards-color mb-md-3 text-up-md d-block">{t("Noches y servicios de hotel gratuitos")}</strong> {t("Acumula puntos y canjéalos por estancias")} </span>
                            </li>
                            <li className="col-md-6 col-xl-3">
                                <figure>
                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_REGALO_Negro.svg" />
                                </figure>
                                <span>
                                    <strong className="rewards-color mb-md-3 text-up-md d-block">{t("Obsequios y atenciones únicas")}</strong> {t("Siéntete especial durante tu estancia")} </span>
                            </li>

                        </ul>

                    </div>
                </div>
            </reward-benefits>
        </div>
    )
}

export default Beneficios;
